import React from "react";

const SvgBars3BottomLeft = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon" {...props}>
    <path
      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgBars3BottomLeft;
